export default __webpack_public_path__ + "static/media/screenshot9.bc633eee.jpg";